<template>
  <normal-mode-template :label="$t('servicesystem.common_objects.machine.contracted_to')">
    <template v-slot:value>
      <div v-if="loading" class="ml-3 mb-2 d-flex align-center">
        <v-progress-circular indeterminate color="primary" />
      </div>
      <div v-else-if="!hasContracts" class="ml-3 mb-2 mt-1 valuetext">
        {{ $t('servicesystem.common_objects.fallbackterms.no_machine_contract') }}
      </div>
      <div v-else class="px-2">
        <v-list dense class="py-0 pb-1">
          <v-list-item v-for="detail in contracts" :key="detail.Id" class="px-2" :to="contractRoute(detail)"
            :class="contractStatusClass(detail)">
            <v-list-item-icon class="my-auto mr-2">
              <v-icon size="20">
                {{ getContractTypeIcon(detail.ContractType.Id) }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content class="py-1">
              <v-list-item-title>
                <a class="text-decoration-none">
                  {{ detail.ContractId }}
                </a>
                {{ detail.Name }}
              </v-list-item-title>
              <v-list-item-title>
                <v-row no-gutters align="center" justify="space-between">
                  <div>
                    <v-chip v-if="detail.ContractType && detail.ContractType.Name" small style="border-radius: 4px;"
                      class="px-2">
                      {{ detail.ContractType.Name }}
                    </v-chip>
                  </div>
                  <div class="caption ml-2" :class="detailStatusClass(detail)" v-if="detailStatus(detail)">
                    {{ detailStatus(detail) }}
                  </div>
                </v-row>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon class="my-auto ml-2">
              <v-icon>
                mdi-chevron-right
              </v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
      </div>
    </template>
  </normal-mode-template>
</template>


<script>
import MachineContractMenuMixin from "@/helpers/Mixins/MachineContractMenuMixin.js";
import NormalModeTemplate from "@/components/Inputs/Parts/NormalModeTemplate.vue";

export default {
  name: "MachineContractHoverCard",
  props: ["id"],
  components: {
    NormalModeTemplate,
  },
  mixins: [MachineContractMenuMixin],

  data() {
    return {};
  },

  mounted() {
    this.fetchByMachineId(this.id);
  },

  methods: {},

  computed: {},

  watch: {
    id: function () {
      this.fetchByMachineId(this.id);
    },
  },
};
</script>


<style lang="scss" scoped>
.terminated-icon {
  color: #4a4a4a !important;
  text-decoration: line-through;
}

.deactivated:not(:hover) {
  color: var(--v-disabled-darken4) !important;
  text-decoration: line-through !important;
}
</style>
